import { render, staticRenderFns } from "./ModalTicketType.vue?vue&type=template&id=886001c2"
import script from "./ModalTicketType.vue?vue&type=script&lang=js"
export * from "./ModalTicketType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports